// Function to identify the correct translation hostname
export function getTranslationHostname(currentHostname: string): string {
  const parts = currentHostname.split('.');

  if (parts.length < 2) {
    return currentHostname;
  }

  const subdomain = parts[0];
  const domain = parts.slice(1).join('.');

  // Check if subdomain includes 'dev' or 'test' (case insensitive)
  const lowerSubdomain = subdomain.toLowerCase();
  const newSubdomain =
    lowerSubdomain.includes('dev') || lowerSubdomain.includes('test')
      ? 't-dev'
      : 't';

  return `${newSubdomain}.${domain}`;
}
